import AiStarIcon from "@redotech/redo-icons/ai-star.svg";
import { Button } from "@redotech/redo-web/components/ui/button";
import { memo } from "react";
import * as styles from "./ask-redo-button.module.css";

type AskRedoButtonProps = { onClick: () => void };

export const AskRedoButton = memo(function AskRedoButton({
  onClick,
}: AskRedoButtonProps) {
  return (
    <Button
      className={`${styles.button} flex gap-1`}
      onClick={onClick}
      size="sm"
    >
      <AiStarIcon className="size-3" />
      <span className="text-xs">Ask Redo</span>
    </Button>
  );
});
